import React from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';

const SuccessPage = () => {
  const { orderId } = useParams();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const guestName = query.get('guestName');
  const amount = query.get('amount');

  return (
    <div className="container" style={{ marginTop: '4rem', padding: '20px' }}>
      <div className="alert alert-success text-center" role="alert" style={{ maxWidth: '700px', margin: 'auto', borderRadius: '10px' }}>
        <h2 className="alert-heading mb-4" style={{ fontWeight: '700' }}>
          🎉 Booking Confirmed! 🎉
        </h2>

        <p className="lead">
          Thank you, <strong>{guestName || 'Guest'}</strong>. Your reservation has been successfully confirmed.
          We look forward to providing you with a comfortable and enjoyable stay.
        </p>

        {orderId && (
          <>
            <p>
              <strong>Booking Reference:</strong>{' '}
              <span style={{ color: '#28a745' }}>{orderId}</span>
            </p>
            <p>
              <strong>Total Amount Paid:</strong> ₹{amount} (incl. 5% GST)
            </p>
          </>
        )}

        <hr />
        <p className="mb-3">
          A confirmation message has been sent to the mobile number & email provided during booking. <br />
          Also you can access and download it anytime from your booking history.
        </p>

        <div className="d-flex justify-content-center gap-3 mt-4">
          <Link
            to="/booking-history"
            className="btn btn-outline-secondary d-inline-flex align-items-center"
          >
            <i className="bi bi-printer me-2"></i> Print Invoice
          </Link>

          <Link
            to="/"
            className="btn btn-primary px-3 py-2"
            style={{ fontSize: '1rem' }}
          >
            Return to Homepage
          </Link>
        </div>

      </div>
    </div>
  );
};

export default SuccessPage;
